var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.imageUrl,"lazy-src":_vm.lazySrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }